module.exports={
    "打开Up直播，直播全世界": "「UpLive」世界をライブ配信！",
    "录制的小视频来自": "「UpLive」ショートムービー",
    "<%=name%>的直播": "<%=name%>のライブ配信！",
    "其他热门直播": "人気キャスト一覧",
    "去查看其他精彩直播": "トップキャストのライブをチェック！",
    "正在加载": "ローディング中",
    "<%=num%>在看": "<%=num%>をみている",
    "系统错误": "システムエラー",
    "获取热门主播失败": "人気欄キャスト一覧を表示できませんでした",
    "主播可能在休息，稍后再来试试吧": "キャストは休憩中です。後ほどお越しください！",
    "没有更多数据了哦": "これ以上のデータがありません",
    "哎哟，页面不见了": "ページが見つかりません",
    "哎哟，页面无法查看，请稍候再试": "ページが見つかりません。しばらくしてからお試してください",
    "1年前": "1年前",
    "<%=num%>月前": "ヶ月前",
    "<%=num%>天前": "日前",
    "<%=num%>小时前": "時間前",
    "<%=num%>分钟前": "分前",
    "刚刚": "今",
    "获取用户信息失败, 请稍后重试": "接続エラーです。しばらくしてからお試してください",
    "评论": "コメント",
    "回复": "返信",
    "查看更多评论": "以前のコメントを見る",
    "图片": "画像",
    "视频": "動画",
    "MM月dd日": "MM月dd日",
    "AF": "アフガニスタン",
    "AL": "アルバニア",
    "DZ": "アルジェリア",
    "AS": "アメリカ領サモア",
    "AD": "アンドラ",
    "AO": "アンゴラ",
    "AI": "アングィラ",
    "AQ": "南極大陸",
    "AG": "アンチグアバーブーダ",
    "AR": "アルゼンチン",
    "AM": "アルメニア",
    "AW": "アルバ",
    "AU": "オーストラリア",
    "AT": "オーストリア",
    "AZ": "アゼルバイジャン",
    "BS": "バハマ",
    "BH": "バーレーン",
    "BD": "バングラデシュ",
    "BB": "バルバドス",
    "BY": "ベラルーシ",
    "BE": "ベルギー",
    "BZ": "ベリーズ",
    "BJ": "ベニン",
    "BM": "バミューダ",
    "BT": "ブータン",
    "BO": "ボリビア",
    "BA": "ボスニア・ヘルツェゴビナ",
    "BW": "ボツワナ",
    "BR": "ブラジル",
    "IO": "イギリス領インド洋地域",
    "VG": "イギリス領バージン諸島",
    "BN": "ブルネイ",
    "BG": "ブルガリア",
    "BF": "ブルキナファソ",
    "BI": "ブルンジ",
    "KH": "カンボジア",
    "CM": "カメルーン",
    "CA": "カナダ",
    "CV": "カーボベルデ",
    "KY": "ケイマン諸島",
    "CF": "中央アフリカ共和国",
    "TD": "チャド",
    "CL": "チリ",
    "CN": "中国",
    "CX": "クリスマス島",
    "CC": "ココス諸島",
    "CO": "コロンビア",
    "KM": "コモロ",
    "CK": "クック諸島",
    "CR": "コスタリカ",
    "HR": "クロアチア",
    "CU": "キューバ",
    "CW": "キュラソー",
    "CY": "キプロス",
    "CZ": "チェコ共和国",
    "CD": "コンゴ民主共和国",
    "DK": "デンマーク",
    "DJ": "ジブチ",
    "DM": "ドミニカ",
    "DO": "ドミニカ共和国",
    "TL": "東ティモール",
    "EC": "エクアドル",
    "EG": "エジプト",
    "SV": "エルサルバドル",
    "GQ": "赤道ギニア",
    "ER": "エリトリア",
    "EE": "エストニア",
    "ET": "エチオピア",
    "FK": "フォークランド諸島",
    "FO": "フェロー諸島",
    "FJ": "フィジー",
    "FI": "フィンランド",
    "FR": "フランス",
    "PF": "フランス領ポリネシア",
    "GA": "ガボン",
    "GM": "ガンビア",
    "GE": "ジョージア",
    "DE": "ドイツ",
    "GH": "ガーナ",
    "GI": "ジブラルタル",
    "GR": "ギリシャ",
    "GL": "グリーンランド",
    "GD": "グレナダ",
    "GU": "グアム",
    "GT": "グアテマラ",
    "GG": "ガーンジー島",
    "GN": "ギニア",
    "GW": "ギニアビサウ",
    "GY": "ガイアナ",
    "HT": "ハイチ",
    "HN": "ホンジュラス",
    "HK": "香港",
    "HU": "ハンガリー",
    "IS": "アイスランド",
    "IN": "インド",
    "ID": "インドネシア",
    "IR": "イラン",
    "IQ": "イラク",
    "IE": "アイルランド",
    "IM": "マン島",
    "IL": "イスラエル",
    "IT": "イタリア",
    "CI": "コー​​トジボワール",
    "JM": "ジャマイカ",
    "JP": "日本",
    "JE": "ジャージー",
    "JO": "ヨルダン",
    "KZ": "カザフスタン",
    "KE": "ケニア",
    "KI": "キリバス",
    "XK": "コソボ",
    "KW": "クウェート",
    "KG": "キルギスタン",
    "LA": "ラオス",
    "LV": "ラトビア",
    "LB": "レバノン",
    "LS": "レソト",
    "LR": "リベリア",
    "LY": "リビア",
    "LI": "リヒテンシュタイン",
    "LT": "リトアニア",
    "LU": "ルクセンブルク",
    "MO": "マカオ",
    "MK": "マケドニア",
    "MG": "マダガスカル",
    "MW": "マラウイ",
    "MY": "マレーシア",
    "MV": "モルディブ",
    "ML": "マリ",
    "MT": "マルタ",
    "MH": "マーシャル諸島",
    "MR": "モーリタニア",
    "MU": "モーリシャス",
    "YT": "マヨット島",
    "MX": "メキシコ",
    "FM": "ミクロネシア",
    "MD": "モルドバ",
    "MC": "モナコ",
    "MN": "モンゴル",
    "ME": "モンテネグロ",
    "MS": "モントセラト",
    "MA": "モロッコ",
    "MZ": "モザンビーク",
    "MM": "ミャンマー",
    "NA": "ナミビア",
    "NR": "ナウル",
    "NP": "ネパール",
    "NL": "オランダ",
    "AN": "オランダ領アンティル",
    "NC": "ニューカレドニア",
    "NZ": "ニュージーランド",
    "NI": "ニカラグア",
    "NE": "ニジェール",
    "NG": "ナイジェリア",
    "NU": "ニウエ",
    "KP": "北朝鮮",
    "MP": "北マリアナ諸島",
    "NO": "ノルウェー",
    "OM": "オマーン",
    "PK": "パキスタン",
    "PW": "パラオ",
    "PS": "パレスチナ",
    "PA": "パナマ",
    "PG": "パプアニューギニア",
    "PY": "パラグアイ",
    "PE": "ペルー",
    "PH": "フィリピン",
    "PN": "ピトケアン",
    "PL": "ポーランド",
    "PT": "ポルトガル",
    "PR": "プエルトリコ",
    "QA": "カタール",
    "CG": "コンゴ共和国",
    "RE": "再会",
    "RO": "ルーマニア",
    "RU": "ロシア",
    "RW": "ルワンダ",
    "BL": "セントバーツ",
    "SH": "セントヘレナ",
    "KN": "セントクリストファー・ネイビス",
    "LC": "セントルシア",
    "MF": "サンマルタン島",
    "PM": "サンピエール島・ミクロン島",
    "VC": "セントビンセントおよびグレナディーン諸島",
    "WS": "サモア",
    "SM": "サン・マリノ",
    "ST": "サントメプリンシペ",
    "SA": "サウジアラビア",
    "SN": "セネガル",
    "RS": "セルビア",
    "SC": "セイシェル",
    "SL": "シエラレオネ",
    "SG": "シンガポール",
    "SX": "シントマールテン島",
    "SK": "スロバキア",
    "SI": "スロベニア",
    "SB": "ソロモン諸島",
    "SO": "ソマリア",
    "ZA": "南アフリカ",
    "KR": "韓国",
    "SS": "南スーダン",
    "ES": "スペイン",
    "LK": "スリランカ",
    "SD": "スーダン",
    "SR": "スリナム",
    "SJ": "スバールバル諸島ヤンマイエン島",
    "SZ": "スワジランド",
    "SE": "スウェーデン",
    "CH": "スイス",
    "SY": "シリア",
    "TW": "台湾",
    "TJ": "タジキスタン",
    "TZ": "タンザニア",
    "TH": "タイ",
    "TG": "行く",
    "TK": "トケラウ諸島",
    "TO": "トンガ",
    "TT": "トリニダード・トバゴ",
    "TN": "チュニジア",
    "TR": "トルコ",
    "TM": "トルクメニスタン",
    "TC": "タークス・カイコス諸島",
    "TV": "ツバル",
    "VI": "米領バージン諸島",
    "UG": "ウガンダ",
    "UA": "ウクライナ",
    "AE": "アラブ首長国連邦",
    "GB": "イギリス",
    "US": "アメリカ",
    "UY": "ウルグアイ",
    "UZ": "ウズベキスタン",
    "VU": "バヌアツ",
    "VA": "バチカン",
    "VE": "ベネズエラ",
    "VN": "ベトナム",
    "WF": "ワリー・エ・フトゥーナ",
    "EH": "西サハラ",
    "YE": "イエメン",
    "ZM": "ザンビア",
    "ZW": "ジンバブエ"
};


// WEBPACK FOOTER //
// ./js/lang/jajp.js